import { Cents, Money } from "@/types/money.types";

// === Constructors / Guards
export const cents = (n: number): Cents => n as Cents;

// === Math helpers (internal use only)
export const add = (a: Cents, b: Cents): Cents => cents(a + b);
export const sub = (a: Cents, b: Cents): Cents => cents(a - b);

// calculate total price (unitPrice * qty)
export const multiplyQty = (unitPrice: Cents, qty: number): Cents =>
  cents(unitPrice * qty);

// sum up a list of cents
export const sum = (items: Cents[]): Cents =>
  cents(items.reduce((acc, v) => acc + v, 0));

// === Format helpers (two decimal places, currency symbol)
export const formatMoney = (m: Money, locale = "en-CA"): string => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: m.currency,
    currencyDisplay: "symbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(m.amount) / 100);
};

export const formatCAD = (amountInCents: Cents): string => {
  return formatMoney({ currency: "CAD", amount: amountInCents });
};

// Parse a string dollar amount (e.g. "12.34") to cents (e.g. 1234)
// Mainly used at the api boundary
export const parseDollarsToCents = (s: string): Cents => {
  const n = Math.round(parseFloat(s.replace(/,/g, "")) * 100);
  return cents(n);
};
